import { isClient } from "@/styles/utils";

export const allOption = {
  name: "Show All",
  value: "all",
};

export const allStoresOption = {
  name: "All Stores",
  value: "all",
};

export const allQuotes = {
  name: "All Quotes",
  value: "all",
};

export const allOpenQuotes = {
  name: "All Open Quotes",
  value: "all-open",
  id: "all-open",
};

export const selectAllOption = {
  value: "select_all",
  label: "Select All",
  id: "select_all",
};

// Order Options
export const orderOptions = [
  {
    name: "Follow Up Date",
    slug: "follow_up_date",
  },
  {
    name: "Date Created",
    slug: "date_created",
  },
  {
    name: "Expiry Date",
    slug: "expiry_date",
  },
];

export const getStoredStatuses = () => {
  return (
    (isClient() &&
      localStorage.selectedQuotesStatuses &&
      JSON.parse(localStorage.getItem("selectedQuotesStatuses"))) ||
    []
  );
};

export const getStoredJobStatuses = () => {
  return (
    (isClient() &&
      localStorage.selectedJobStatuses &&
      JSON.parse(localStorage.getItem("selectedJobStatuses"))) ||
    []
  );
};

export const getStoredJobSlugs = () => {
  const statuses = getStoredJobStatuses();
  return statuses
    .map((status) => (status.toggle ? status.slug : null))
    .filter((slug) => slug !== null);
};

export const storeStatuses = (selectedStatuses) => {
  localStorage.setItem(
    "selectedQuotesStatuses",
    JSON.stringify(selectedStatuses),
  );
};

export const storeJobStatuses = (selectedStatuses) => {
  localStorage.setItem("selectedJobStatuses", JSON.stringify(selectedStatuses));
};

export const getQuotesListingFilters = () => {
  if (
    isClient() &&
    localStorage.quotesListingFilters &&
    localStorage.quotesListingFilters !== "false"
  ) {
    return JSON.parse(localStorage.quotesListingFilters);
  } else {
    return {
      builder: allOption,
      colourRoom: allOption,
      consultant: allOption,
      groupFilters: allStoresOption,
      filteredStatus: allOpenQuotes,
    };
  }
};

export const storeQuotesListingFilters = (newFilters) => {
  localStorage.quotesListingFilters = JSON.stringify(newFilters);
};

export const deleteStoredQuotesListingFilters = () => {
  delete window.localStorage.quotesListingFilters;
};

// Orders
export const getOrdersListingFilters = () => {
  if (
    isClient() &&
    localStorage.ordersListingFilters &&
    localStorage.ordersListingFilters !== "false"
  ) {
    return JSON.parse(localStorage.ordersListingFilters);
  } else {
    return {
      builder: allOption,
      colourRoom: allOption,
      consultant: allOption,
      filteredStatus: allOpenQuotes,
    };
  }
};

export const storeOrdersListingFilters = (newFilters) => {
  localStorage.ordersListingFilters = JSON.stringify(newFilters);
};

export const deleteStoredOrdersListingFilters = () => {
  delete window.localStorage.ordersListingFilters;
};

export const storeActiveSortBy = (activeSortBy) => {
  if (isClient()) localStorage.jobsListingOrder = activeSortBy;
};

export const getStoredActiveSortBy = () => {
  return (isClient() && localStorage.jobsListingOrder) || orderOptions[0]?.slug;
};

export const getStoredAuthentication = () => {
  return window.localStorage.authenticated;
};
export const storeAuthentication = (authenticated) => {
  window.localStorage.authenticated = authenticated;
};
export const deleteStoredAuthentication = () => {};

const defaultSortByTab = {
  pending: "eta-date",
  received: "received-date",
  scheduled: "install-date",
} as const;

export const clearOrderActivitiesFilters = (orderType?: string) => {
  if (!isClient()) return;

  if (orderType) {
    localStorage.removeItem(`order_activities_filters_${orderType}`);
  }
};

export const getOrderActivitiesFilters = (orderType: string) => {
  if (!isClient()) return null;

  const filters = localStorage.getItem(`order_activities_filters_${orderType}`);
  if (!filters) return null;

  try {
    const parsedFilters = JSON.parse(filters);
    return {
      sort_by:
        parsedFilters.sort_by || defaultSortByTab[orderType] || "eta-date",
      locations: Array.isArray(parsedFilters.locations)
        ? parsedFilters.locations
        : [],
      installers: Array.isArray(parsedFilters.installers)
        ? parsedFilters.installers
        : [],
      search: parsedFilters.search || "",
    };
  } catch (error) {
    return null;
  }
};

export const storeOrderActivitiesFilters = (
  orderType: string,
  filters: Record<string, any>,
) => {
  if (!isClient()) return;

  try {
    const filtersToStore = {
      sort_by: filters.sort_by || defaultSortByTab[orderType] || "eta-date",
      locations: Array.isArray(filters.locations) ? filters.locations : [],
      installers: Array.isArray(filters.installers) ? filters.installers : [],
      search: filters.search || "",
    };

    localStorage.setItem(
      `order_activities_filters_${orderType}`,
      JSON.stringify(filtersToStore),
    );
  } catch (error) {
    console.error("Error storing filters:", error);
  }
};
